// extracted by mini-css-extract-plugin
export default {"container":"login_container__e4fy3","copyright":"login_copyright__7DKfi","ahover":"login_ahover__wBhdj"};